import * as React from 'react';

export default () => <div className="mb-30">
  Do you want to remove this position?
</div>;
